// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3Hl_V","large":"styles_large__5hnMz"};